exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-candles-yaml-slug-tsx": () => import("./../../../src/pages/{candlesYaml.slug}.tsx" /* webpackChunkName: "component---src-pages-candles-yaml-slug-tsx" */),
  "component---src-pages-charities-charities-yaml-slug-tsx": () => import("./../../../src/pages/charities/{charitiesYaml.slug}.tsx" /* webpackChunkName: "component---src-pages-charities-charities-yaml-slug-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

